/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ParameterConstraintForAllowedValues extends models.ParameterConstraintBaseForString {
    constructor() {
        super();
        this.setDiscriminator("ParameterConstraintForAllowedValues");
    }

    getFixupPrototypeFunction() { return ParameterConstraintForAllowedValues.fixupPrototype; }

    static newInstance(model: Partial<ParameterConstraintForAllowedValues>): ParameterConstraintForAllowedValues {
        let obj = Object.assign(new ParameterConstraintForAllowedValues(), model);
        ParameterConstraintForAllowedValues.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ParameterConstraintForAllowedValues>): ParameterConstraintForAllowedValues {
        if (!model) return null;
        return ParameterConstraintForAllowedValues.newInstance(<ParameterConstraintForAllowedValues> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ParameterConstraintForAllowedValues) {
        if (!obj) return;

        models.ParameterConstraintForAllowedValues.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ParameterConstraintForAllowedValues): boolean {
        if (models.ParameterConstraintBaseForString.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ParameterConstraintForAllowedValues.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.allowed_values) {
            for (let val of this.allowed_values) {
                models.ParameterConstraintAllowedValue.fixupPrototype(val);
            }
        }
    }

    /**
     * List of allowed values for the parameter
     */
    allowed_values: Array<models.ParameterConstraintAllowedValue>;

}
